import React from 'react';
import { createRoot } from 'react-dom/client';
import AdditionalResources from '../component-selector/components/AdditionalResources';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.additional-resources').forEach(container => {
    const series = container.dataset.seriesTitle || '';
    const root = createRoot(container);
    root.render(<AdditionalResources selectedSeries={ series ? [series] : [] } />);
  });
});
